// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2TA4r","content":"ManualTimeModal_content__U1T9a"};